// extracted by mini-css-extract-plugin
export default {"formHeading":"SH-z","form":"TH-z","submitBtn":"UH-z","disabled":"VH-z","input":"WH-z","error":"XH-z","submitMsg":"YH-z","signIn":"ZH-z"};